import { auth, db } from "../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";

// Function to save form data for Section 2
export const writeDataS2 = async (formData) => {
  // console.log("Form data for Section 2: ", formData);
  const user = auth.currentUser;
  try {
  

    const docRef = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Professional Qualifications"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 2 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 2 data to Firestore: ", error);
  }
};


